// The font picker's option for a value, out of window.FONT_FAMILY_OPTIONS_FOR_FONT_SELECT_COMPONENT
// (Font#to_font_select_hash). Match by `value` first (e.g. "Lato"), then by the actual font-family
// CSS string ("my-custom-font"), since that's what the editor writes into the DOM for custom fonts.
//
// Shared by the font select and the TipTap toolbar sync: the toolbar only hands the select a
// value this finds, because the select ignores one it can't match and keeps showing the old font.
export function findFontOption(options, value) {
  if (!options) return undefined

  return (
    options.find((font) => font.value == value) ||
    options.find((font) => font.extraData?.cssString == value)
  )
}
